/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Embed_Export_Target_LabelInputs */



/**
* | output |
* | --- |
* | "Target folder" |
*
* @param {Audio_Embed_Export_Target_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_embed_export_target_label = /** @type {((inputs?: Audio_Embed_Export_Target_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Embed_Export_Target_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Dossier cible")
	if (locale === "de") return /** @type {LocalizedString} */ ("Zielordner")
	if (locale === "it") return /** @type {LocalizedString} */ ("Cartella di destinazione")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Целевая папка")
	if (locale === "es") return /** @type {LocalizedString} */ ("Carpeta de destino")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("目标文件夹")
	if (locale === "ja") return /** @type {LocalizedString} */ ("対象フォルダー")
	if (locale === "hi") return /** @type {LocalizedString} */ ("लक्ष्य फ़ोल्डर")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Pasta de destino")
	return /** @type {LocalizedString} */ ("Target folder")
});